import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';
import GroupListSkeleton from '@components/Home/Skeleton/GroupListSkeleton';
import TotalPortfolioListSkeleton from '@components/Home/Skeleton/TotalPortfolioListSkeleton';

const GroupList = lazy(() => import('@components/Home/GroupList'));
const TotalPortfolioList = lazy(
  () => import('@components/Home/TotalPortfolioList')
);

/** 홈 > 조합 관리 */
const Group = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense fallback={<GroupListSkeleton isButtonShow />}>
          <GroupList title="조합관리" isButtonShow />
        </Suspense>
      </ApiErrorBoundary>

      <ApiErrorBoundary>
        <Suspense fallback={<TotalPortfolioListSkeleton />}>
          <TotalPortfolioList />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default Group;
